module.exports = __webpack_public_path__ + "static/media/sportireland.524a04b5.png";